var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ssoHeaderBig" } }, [
    _c("div", { attrs: { id: "ssoHeaderSma" } }, [
      _c("span", { staticClass: "logo", on: { click: _vm.toIndex } }),
      _vm._v(" "),
      _c("span", { staticClass: "userBox" }, [
        _c(
          "span",
          { staticClass: "noLogin login" },
          [_c("router-link", { attrs: { to: "/login" } }, [_vm._v("登录")])],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "noLogin register" },
          [_c("router-link", { attrs: { to: "/register" } }, [_vm._v("注册")])],
          1
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "logo_line" }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "logo_item" },
        _vm._l(_vm.nav, function(el, index) {
          return _c("span", { staticClass: "navSpan" }, [
            _c("a", { attrs: { href: el.url } }, [_vm._v(_vm._s(el.name))])
          ])
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cc8dbda", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc8dbda","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sso/components/header/header.vue
// module id = 447
// module chunks = 0